import {ModuleRegistry, AllCommunityModule, provideGlobalGridOptions} from 'ag-grid-community'
import {AllEnterpriseModule, IntegratedChartsModule, LicenseManager as AgGridLicenseManager} from 'ag-grid-enterprise'
import {AgChartsEnterpriseModule, LicenseManager as AgChartsLicenseManager} from 'ag-charts-enterprise'
import {AG_GRID_LOCALE_NO} from '@ag-grid-community/locale'
import 'ag-charts-enterprise'

AgGridLicenseManager.setLicenseKey(import.meta.env.VITE_AG_GRID_ENTERPRISE_KEY)
AgChartsLicenseManager.setLicenseKey(import.meta.env.VITE_AG_GRID_ENTERPRISE_KEY)

ModuleRegistry.registerModules([
    AllCommunityModule,
    AllEnterpriseModule,
    IntegratedChartsModule.with(AgChartsEnterpriseModule)
])

export const globalDefaultColDef = {
    suppressHeaderMenuButton: true
}

provideGlobalGridOptions({
    defaultColDef: globalDefaultColDef,
    localeText: AG_GRID_LOCALE_NO
})

